import { api } from '@/api';
import { PaginatedBody } from '@/api/types';
import { Driver, PaginatedDriverListFilters } from '@/api/apis/resources';
import { getTxCenterProvidersByIds } from '../txcenter-providers';

export const getBannedDriversListWithProvider = async (
  pagination: PaginatedDriverListFilters,
): Promise<PaginatedBody<Driver>> => {
  const data = await api.resource.getBannedDriversList(pagination);

  if (data?.items) {
    const providersIds = data.items.map((c) => c.txCenterProviderId ?? '').filter(Boolean);

    const txCenterProviders = await getTxCenterProvidersByIds(providersIds);

    const mappedItems = data.items.map((item) => {
      let provider = null;

      if (txCenterProviders?.items) {
        provider = txCenterProviders.items.find((e) => e.id === item.txCenterProviderId);
      }

      return {
        ...item,
        provider: provider || undefined,
      };
    });

    return {
      ...data,
      items: mappedItems,
    };
  }

  return data;
};

export const getBannedDriverIdWithProvider = async (id: string): Promise<Driver> => {
  const data = await api.resource.getBannedDriversById(id);

  if (!data || !data.txCenterProviderId) {
    return data;
  }

  const txCenterProvider = await api.txcenterprovider.getTXCenterProvidersById(data.txCenterProviderId);

  return {
    ...data,
    provider: txCenterProvider || undefined,
  };
};
